module.exports = __webpack_public_path__ + "img/frame.3f3d1d76.png";